import React from 'react'
import "./Testimonials.css"
export default function Testimonials() {
	return (
		<div className='contain'>
			<div className='testimonials'>
				<h2 className="h2">Testimonials</h2>
				<div id="myCarousel" class="carousel slide" data-ride="carousel">
					{/* <!-- Carousel indicators --> */}
					<ol class="carousel-indicators">
						<li data-target="#myCarousel" data-slide-to="0" class="active"></li>
						<li data-target="#myCarousel" data-slide-to="1"></li>
						<li data-target="#myCarousel" data-slide-to="2"></li>
					</ol>
					{/* <!-- Wrapper for carousel items --> */}
					<div class="carousel-inner">
						<div class="carousel-item active">
							<div class="img-box"><img src="/examples/images/clients/3.jpg" alt="" /></div>
							<p class="testimonial">Phasellus vitae suscipit justo. Mauris pharetra feugiat ante id lacinia. Etiam faucibus mauris id tempor egestas. Duis luctus turpis at accumsan tincidunt. Phasellus risus risus, volutpat vel tellus ac, tincidunt fringilla massa. Etiam hendrerit dolor eget rutrum.</p>
							<p class="overview"><b>Michael Holz</b><br />
								Seo Analyst at <a href="#">OsCorp Tech.</a></p>
							<div class="star-rating">
								<ul class="list-inline">
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star-o"></i></li>
								</ul>
							</div>
						</div>
						<div class="carousel-item">
							<div class="img-box"><img src="/examples/images/clients/1.jpg" alt="" /></div>
							<p class="testimonial">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu sem tempor, varius quam at, luctus dui. Mauris magna metus, dapibus nec turpis vel, semper malesuada ante. Vestibulum idac nisl bibendum scelerisque non non purus. Suspendisse varius nibh non aliquet.</p>
							<p class="overview"><b>Paula Wilson</b><br />
								Media Analyst at <a href="#">SkyNet Inc.</a></p>
							<div class="star-rating">
								<ul class="list-inline">
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star-o"></i></li>
								</ul>
							</div>
						</div>
						<div class="carousel-item">
							<div class="img-box"><img src="/examples/images/clients/1.jpg" alt="" /></div>
							<p class="testimonial">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu sem tempor, varius quam at, luctus dui. Mauris magna metus, dapibus nec turpis vel, semper malesuada ante. Vestibulum idac nisl bibendum scelerisque non non purus. Suspendisse varius nibh non aliquet.</p>
							<p class="overview"><b>Paula Wilson</b><br />
								Media Analyst at <a href="#">SkyNet Inc.</a></p>
							<div class="star-rating">
								<ul class="list-inline">
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star-o"></i></li>
								</ul>
							</div>
						</div>
						<div class="carousel-item">
							<div class="img-box"><img src="/examples/images/clients/2.jpg" alt="" /></div>
							<p class="testimonial">Vestibulum quis quam ut magna consequat faucibus. Pellentesque eget nisi a mi suscipit tincidunt. Utmtc tempus dictum risus. Pellentesque viverra sagittis quam at mattis. Suspendisse potenti. Aliquam sit amet gravida nibh, facilisis gravida odio. Phasellus auctor velit.</p>
							<p class="overview"><b>Antonio Moreno</b><br />
								Web Developer at <a href="#">Circle Ltd.</a></p>
							<div class="star-rating">
								<ul class="list-inline">
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star"></i></li>
									<li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
								</ul>
							</div>
						</div>
					</div>
					{/* <!-- Carousel controls --> */}
					<div className='btn'>
						<a class="carousel-control-prev" href="#myCarousel" data-slide="prev">
							<i class="fa fa-angle-left"></i>
						</a>
						<a class="carousel-control-next" href="#myCarousel" data-slide="next">
							<i class="fa fa-angle-right"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}
